/**
 * Materials for a whole floor plan: every room's walls and ceiling, as one
 * project — the SlatWall offcut pool runs across rooms, as the engine's does
 * across walls. A wall two rooms share has two faces; each room's side is its
 * own surface, so both are counted.
 *
 * Framing is not counted here (it is not in the bill of materials at all yet).
 */

import { Surface } from '../../types/sections';
import { calculateFromSurfaces, SurfacesEstimate } from '../sections/calculateFromSurfaces';
import { FloorPlan, roomWallSurfaces } from './floorPlan';

/** Every surface on the plan, room by room — walls with their outlines under a sloped ceiling. */
export function planSurfaces(plan: FloorPlan): Surface[] {
  return plan.rooms.flatMap((room) => [
    ...roomWallSurfaces(room),
    ...(room.surfaces.ceiling ? [room.surfaces.ceiling] : []),
    ...Object.values(room.surfaces.ceilingPlanes ?? {}),
  ]);
}

export function calculateFromPlan(plan: FloorPlan): SurfacesEstimate {
  // The section maths walks `walls` then `ceiling` and treats each surface by
  // its own kind, so a flat list of every room's surfaces is one "room" to it.
  return calculateFromSurfaces({ walls: planSurfaces(plan) });
}
